import React, { useState } from 'react';
import { FormTitle } from '@molecules/index';
import { UploadPhoto } from '../../molecules/UploadPhoto/UploadPhoto';
import { ErrorMessages } from '@types';

type UploadPhotoFormProps = {
  id?: string;
  formTitle?: string;
  description?: string | React.ReactNode;
  handleFileChange: (files: File[]) => void | Promise<void>;
  handleUploadError: (error: string) => void;
  handleDelete?: (files: File[]) => void | Promise<void>;
  maxNumberOfUpload?: number;
  errorPath?: string;
  errorMessages?: ErrorMessages[];
  initialFiles?: File[];
};

export const UploadPhotoForm: React.FC<UploadPhotoFormProps> = ({
  id,
  formTitle,
  description,
  handleFileChange,
  handleUploadError,
  handleDelete,
  maxNumberOfUpload = 1,
  errorPath,
  errorMessages,
  initialFiles,
}) => {
  return (
    <div>
      {formTitle && <FormTitle text={formTitle} subtext={description} />}
      <UploadPhoto
        // id set to errorPath so that error can navigate to the correct upload photo
        id={errorPath ?? id}
        handleFileChange={handleFileChange}
        handleUploadError={handleUploadError}
        handleDelete={handleDelete}
        maxNumberOfUpload={maxNumberOfUpload}
        errorPath={errorPath}
        errorMessages={errorMessages}
        initialFiles={initialFiles}
      />
    </div>
  );
};
